import { Mail, Phone } from 'lucide-react';

interface ContactCardDesktopProps {
  label: string;
  name: string;
  email: string;
  phone: string;
}

const ContactCardDesktop = ({
  label,
  name,
  email,
  phone,
}: ContactCardDesktopProps) => {
  return (
    <div className="flex w-full flex-col gap-4 rounded-xl bg-surface-inverse p-6 px-7">
      <span className="font-body text-[11px] font-semibold uppercase tracking-[0.5px] text-accent-primary">
        {label}
      </span>
      <span className="font-heading text-lg font-medium text-foreground-inverse">
        {name}
      </span>
      <div className="flex gap-3">
        <a
          href={`mailto:${email}`}
          className="flex items-center gap-2 rounded-lg border border-white/20 px-4 py-2.5 transition-colors hover:border-white/40"
        >
          <Mail className="h-4 w-4 text-white/80" />
          <span className="font-body text-sm text-foreground-inverse">
            {email}
          </span>
        </a>
        <a
          href={`tel:${phone}`}
          className="flex items-center gap-2 rounded-lg border border-white/20 px-4 py-2.5 transition-colors hover:border-white/40"
        >
          <Phone className="h-4 w-4 text-white/80" />
          <span className="font-body text-sm text-foreground-inverse">
            {phone}
          </span>
        </a>
      </div>
    </div>
  );
};

export default ContactCardDesktop;
